<style scoped>
.input-sublinhado {
    border: none;
    border-bottom: 1px solid black;
    /* Ajuste a espessura e cor conforme necessário */
    outline: none;
    /* Remove o contorno ao focar */
    background: transparent;
    /* Remove fundo branco padrão */
    /* padding: 5px; */
    /* Ajusta o espaçamento interno */
    font-size: 16px;
    width: 100px;
    /* Ajuste conforme necessário */
}

.input-sublinhado:focus {
    border-bottom: 1px solid blue;
    /* Muda a cor ao focar (opcional) */
}

.slide-fade-enter-active {
    transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
    transform: translateX(20px);
    opacity: 0;
}



.slide-fade-2-enter-active {
    transition: all 0.3s ease-out;
}

.slide-fade-2-leave-active {
    transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-2-enter-from,
.slide-fade-2-leave-to {
    transform: translateX(20px);
    opacity: 0;
}

input[type="radio"] {
    appearance: none;
    width: 20px;
    height: 20px;
    border: 2px solid #e5d3d8;
    cursor: pointer;
}

.tooltip-form {
    text-decoration: underline;
    font-size: 14px;
    color: black;
}

.btn-verde {
    background-color: #198754;
}

.btn-verde:hover {
    background-color: #157347;
    /* Cor padrão do hover do Bootstrap */
    border-color: #146c43;
    /* Borda no hover */
}
</style>

<template>

    <!-- --------- -->
    <div class="row padding_categoria" id="receba">
        <div class="col-md-8 offset-md-2 corner-radius relative"
            style="background-color: #fff; padding-top: 30px; margin-bottom: 30px; padding-bottom: 30px;">
            <div class="border_sup_esq">
                <img :src="require('@/assets/images/border_sup_esq.png')">
            </div>
            <div class="border_sup_dir">
                <img :src="require('@/assets/images/border_sup_dir.png')">
            </div>
            <div class="border_inf_esq">
                <img :src="require('@/assets/images/border_inf_esq.png')">
            </div>
            <div class="border_inf_dir">
                <img :src="require('@/assets/images/border_inf_dir.png')">
            </div>
            <!------ FORMULARIO ----- -->
            <div class="row" v-if="!formularioStore.pix_codigo && !formularioStore.boleto_codigo">
                <div class="col-md-8 offset-md-2">
                    <form @submit.prevent="submitForm">
                        <div class="row">
                            <div class="col-md-12">
                                <label for="nome" class="form-label form-titulo">Nome e Sobrenome<span
                                        class="vermelho">*</span>:</label>
                                <input v-model="formularioStore.doador.nome" type="text" class="form-control" id="nome"
                                    aria-describedby="nome"
                                    :class="{ 'is-invalid': formularioStore.errors.nome, 'is-valid': formularioStore.validated.nome }">
                                <span v-if="formularioStore.errors.nome" class="text-danger">
                                    {{ formularioStore.errors.nome }}
                                </span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="col-md-12">
                                    <label for="cep" class="form-label form-titulo">CEP<span class="vermelho">*</span>:
                                    </label>
                                    <input v-model="formularioStore.doador.endereco.cep" v-mask="'#####-###'" type="tel"
                                        class="form-control" id="cep" aria-describedby="cep"
                                        :class="{ 'is-invalid': formularioStore.errors.cep, 'is-valid': formularioStore.validated.cep }"
                                        @blur="formularioStore.buscarEndereco()">
                                    <span v-if="formularioStore.errors.cep" class="text-danger">
                                        {{ formularioStore.errors.cep }}
                                    </span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="col-md-12">
                                    <label for="cidade" class="form-label form-titulo"> Cidade<span
                                            class="vermelho">*</span>:</label>
                                    <input v-model="formularioStore.doador.endereco.cidade" type="text"
                                        class="form-control" id="cidade" aria-describedby="cidade"
                                        :class="{ 'is-invalid': formularioStore.errors.cidade, 'is-valid': formularioStore.validated.cidade }">
                                    <span v-if="formularioStore.errors.cidade" class="text-danger">
                                        {{ formularioStore.errors.cidade }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="col-md-12">
                                    <label for="bairro" class="form-label form-titulo">Bairro<span
                                            class="vermelho">*</span>:</label>
                                    <input v-model="formularioStore.doador.endereco.bairro" type="text"
                                        class="form-control" id="bairro" aria-describedby="bairro"
                                        :class="{ 'is-invalid': formularioStore.errors.bairro, 'is-valid': formularioStore.validated.bairro }">
                                    <span v-if="formularioStore.errors.bairro" class="text-danger">
                                        {{ formularioStore.errors.bairro }}
                                    </span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="col-md-12">
                                    <label for="endereco" class="form-label form-titulo">Endereço<span
                                            class="vermelho">*</span>:</label>
                                    <input v-model="formularioStore.doador.endereco.logradouro" type="text"
                                        class="form-control" id="endereco" aria-describedby="endereco"
                                        :class="{ 'is-invalid': formularioStore.errors.endereco, 'is-valid': formularioStore.validated.endereco }">
                                    <span v-if="formularioStore.errors.endereco" class="text-danger">
                                        {{ formularioStore.errors.endereco }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="col-md-12">
                                    <label for="numero" class="form-label form-titulo">Número<span
                                            class="vermelho">*</span>:</label>
                                    <input v-model="formularioStore.doador.endereco.numero" type="text"
                                        class="form-control" id="numero" aria-describedby="numero"
                                        :class="{ 'is-invalid': formularioStore.errors.numero, 'is-valid': formularioStore.validated.numero }">
                                    <span v-if="formularioStore.errors.numero" class="text-danger">
                                        {{ formularioStore.errors.numero }}
                                    </span>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="col-md-12">
                                    <label for="complemento" class="form-label form-titulo">Complemento:</label>
                                    <input v-model="formularioStore.doador.endereco.complemento" type="text"
                                        class="form-control" id="complemento" aria-describedby="complemento"
                                        maxlength="50">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <!-- SELECT com todos os estados -->
                                <div class="col-md-12">
                                    <label for="estado" class="form-label form-titulo">Estado:</label>
                                    <!-- <input v-model="formularioStore.doador.endereco.estado" type="text"
                                            class="form-control" id="estado" aria-describedby="estado"
                                            :class="{ 'is-invalid': formularioStore.errors.estado, 'is-valid': formularioStore.validated.estado }"> -->
                                    <select v-model="formularioStore.doador.endereco.estado" class="form-select"
                                        id="estado" aria-describedby="estado"
                                        :class="{ 'is-invalid': formularioStore.errors.estado, 'is-valid': formularioStore.validated.estado }">
                                        <option value="AC">Acre</option>
                                        <option value="AL">Alagoas</option>
                                        <option value="AP">Amapá</option>
                                        <option value="AM">Amazonas</option>
                                        <option value="BA">Bahia</option>
                                        <option value="CE">Ceará</option>
                                        <option value="DF">Distrito Federal</option>
                                        <option value="ES">Espírito Santo</option>
                                        <option value="GO">Goiás</option>
                                        <option value="MA">Maranhão</option>
                                        <option value="MT">Mato Grosso</option>
                                        <option value="MS">Mato Grosso do Sul</option>
                                        <option value="MG">Minas Gerais</option>
                                        <option value="PA">Pará</option>
                                        <option value="PB">Paraíba</option>
                                        <option value="PR">Paraná</option>
                                        <option value="PE">Pernambuco</option>
                                        <option value="PI">Piauí</option>
                                        <option value="RJ">Rio de Janeiro</option>
                                        <option value="RN">Rio Grande do Norte</option>
                                        <option value="RS">Rio Grande do Sul</option>
                                        <option value="RO">Rondônia</option>
                                        <option value="RR">Roraima</option>
                                        <option value="SC">Santa Catarina</option>
                                        <option value="SP">São Paulo</option>
                                        <option value="SO">Sergipe</option>
                                        <option value="TO">Tocantins</option>
                                    </select>
                                    <span v-if="formularioStore.errors.estado" class="text-danger">
                                        {{ formularioStore.errors.estado }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="col-md-12">
                                    <label for="email" class="form-label form-titulo">E-mail<span
                                            class="vermelho">*</span>:</label>
                                    <div id="" class="form-text form-subtitulo">(Para confirmação e eventual
                                        contato)</div>
                                    <input v-model="formularioStore.doador.email" type="email" class="form-control"
                                        id="email" aria-describedby="email"
                                        :class="{ 'is-invalid': formularioStore.errors.email, 'is-valid': formularioStore.validated.email }">
                                    <span v-if="formularioStore.errors.email" class="text-danger">
                                        {{ formularioStore.errors.email }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="col-md-12">
                                    <label for="confirme_email" class="form-label form-titulo">Confirme seu
                                        e-mail<span class="vermelho">*</span>:</label>
                                    <input v-model="formularioStore.confirme_email" type="email" class="form-control"
                                        id="confirme_email" aria-describedby="confirme_email"
                                        :class="{ 'is-invalid': formularioStore.errors.confirme_email, 'is-valid': formularioStore.validated.confirme_email }">
                                    <span v-if="formularioStore.errors.confirme_email" class="text-danger">
                                        {{ formularioStore.errors.confirme_email }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="col-md-12">
                                    <label for="whatsapp" class="form-label form-titulo">Whatsapp com DDD:</label>
                                    <div id="" class="form-text form-subtitulo">(recomendado para eventuais dúvidas
                                        no envio)</div>
                                    <input v-model="formularioStore.whatsapp" v-mask="'(##) #####-####'" type="tel"
                                        class="form-control" id="whatsapp" aria-describedby="whatsapp"
                                        :class="{ 'is-invalid': formularioStore.errors.whatsapp, 'is-valid': formularioStore.validated.whatsapp }">
                                    <span v-if="formularioStore.errors.whatsapp" class="text-danger">
                                        {{ formularioStore.errors.whatsapp }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="col-md-12">
                                    <label for="cpf">CPF <span class="text-danger">*</span>: <a class="tooltip-form"
                                            data-bs-toggle="tooltip"
                                            data-bs-title="Solicitamos o CPF para garantir a correta identificação do envio, evitar duplicidades e reforçar a segurança e transparência do processo. Seus dados estão protegidos e não serão compartilhados.">(Por
                                            quê?)</a>
                                    </label>
                                    <input v-model="formularioStore.doador.documento" v-mask="'###.###.###-##'"
                                        type="tel" class="form-control" id="cpf" aria-describedby="cpf"
                                        :class="{ 'is-invalid': formularioStore.errors.documento, 'is-valid': formularioStore.validated.documento }">
                                    <span v-if="formularioStore.errors.documento" class="text-danger">
                                        {{ formularioStore.errors.documento }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row padding_categoria">
                            <div class="col-md-12">
                                <p>
                                    <b>Colaboração espontânea (opcional):</b>
                                </p>
                                <p>
                                    Se deseja participar deste apostolado e permitir que ampliemos a distribuição
                                    desta Estampa a mais famílias, colabore com um valor abaixo:
                                </p>
                            </div>
                        </div>
                        <span v-if="formularioStore.errors.doacao" class="text-danger">{{
                            formularioStore.errors.doacao }}</span>
                        <div class="row padding_form">
                            <div class="col-md-12">
                                <div class="form-check">
                                    <input v-model="formularioStore.valor_doacao" value="20" class="form-check-input"
                                        type="radio" name="flexRadioDefault" id="val20"
                                        @click="formularioStore.setValorOutroValor()">
                                    <label class="form-check-label" for="val20">
                                        R$ 20,00
                                    </label>
                                </div>
                                <div class="form-check mt-2">
                                    <input v-model="formularioStore.valor_doacao" value="30" class="form-check-input"
                                        type="radio" name="flexRadioDefault" id="val30"
                                        @click="formularioStore.setValorOutroValor()">
                                    <label class="form-check-label" for="val30">
                                        R$ 30,00
                                    </label>
                                </div>
                                <div class="form-check mt-2">
                                    <input v-model="formularioStore.valor_doacao" value="50" class="form-check-input"
                                        type="radio" name="flexRadioDefault" id="val50"
                                        @click="formularioStore.setValorOutroValor()">
                                    <label class="form-check-label" for="val50">
                                        R$ 50,00
                                    </label>
                                </div>
                                <div class="form-check mt-2">
                                    <input class="form-check-input" type="radio" name="flexRadioDefault" id="valoutro"
                                        @click="formularioStore.setValorDoacao()">
                                    <label class="form-check-label">
                                        Outro valor: R$ <input v-model="formularioStore.outro_valor" type="text"
                                            class="input-sublinhado" @keypress="setaCheckbox" v-money="money">,
                                        pois quero impulsionar esse apostolado. Que Nossa Senhora de Fátima me ajude.
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="row padding_form mt-3">
                            <div class="row">
                                <div class="col-md-12">
                                    <b>Escolha como prefere fazer a sua doação segura:</b>
                                </div>
                                <span v-if="formularioStore.errors.forma_pagamento" class="text-danger">{{
                                    formularioStore.errors.forma_pagamento }}</span>
                            </div>
                            <div class="row mt-2">
                                <div class="col-md-4 mt-2">
                                    <div class="col-md-12">
                                        <div class="form-check">
                                            <input v-model="formularioStore.forma_pagamento" value="credito"
                                                class="form-check-input" type="radio" name="pagamento" id="escCredito"
                                                @click="formularioStore.setFormaDePagamento()">
                                            <label class="form-check-label" for="escCredito">
                                                Cartão de Crédito
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2 mt-2">
                                    <div class="col-md-12">
                                        <div class="form-check">
                                            <input v-model="formularioStore.forma_pagamento" value="pix"
                                                class="form-check-input" type="radio" name="pagamento" id="escPix"
                                                @click="formularioStore.setFormaDePagamento()">
                                            <label class="form-check-label" for="escPix">
                                                Pix
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3 mt-2">
                                    <div class="col-md-12">
                                        <div class="form-check">
                                            <input v-model="formularioStore.forma_pagamento" value="boleto"
                                                class="form-check-input" type="radio" name="pagamento" id="escBoleto"
                                                @click="formularioStore.setFormaDePagamento()">
                                            <label class="form-check-label" for="escBoleto">
                                                Boleto
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3 mt-2">
                                    <div class="col-md-12">
                                        <div class="form-check">
                                            <input v-model="formularioStore.forma_pagamento" value="paypal"
                                                class="form-check-input" type="radio" name="pagamento" id="escPaypal"
                                                @click="formularioStore.setFormaDePagamento()">
                                            <label class="form-check-label" for="escPaypal">
                                                Paypal
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row padding_form mt-1">
                            <div class="col-md-12">
                                <div class="form-check">
                                    <input v-model="formularioStore.nao_quero_colaborar" value="true"
                                        class="form-check-input" type="radio" name="flexRadioDefault" id="valnaoquero"
                                        @click="formularioStore.setNaoQueroColaborar()">
                                    <label class="form-check-label fw-bold" for="valnaoquero">
                                        Não quero colaborar no momento
                                    </label>
                                </div>
                            </div>
                        </div>

                        <!-- INPUTS CARTAO DE CRÉDITO -->
                        <Transition name="slide-fade">
                            <div class="row" v-if="formularioStore.forma_pagamento == 'credito'">
                                <div class="col-md-12">
                                    <label for="credito" class="form-label form-titulo">Número do cartão<span
                                            class="vermelho">*</span>:</label>
                                    <input v-model="formularioStore.numero_cartao" v-mask="'#### #### #### ####'"
                                        type="tel" class="form-control" id="credito" aria-describedby="credito"
                                        @blur="formularioStore.bandeiraCartao()"
                                        @keyup="formularioStore.transicaoForm()"
                                        :class="{ 'is-invalid': formularioStore.errors.numero_cartao, 'is-valid': formularioStore.validated.numero_cartao }">
                                    <span v-if="formularioStore.errors.numero_cartao" class="text-danger">
                                        {{ formularioStore.errors.numero_cartao }}
                                    </span>
                                </div>
                            </div>
                        </Transition>

                        <Transition name="slide-fade-2">
                            <div class="row"
                                v-if="formularioStore.transicao && formularioStore.forma_pagamento == 'credito'">
                                <div class="col-md-6">
                                    <label for="exp_cartao" class="form-label form-titulo">Vencimento<span
                                            class="vermelho">*</span>:</label>
                                    <input v-model="formularioStore.exp_cartao" v-mask="'##/##'" type="text"
                                        class="form-control" id="exp_cartao" aria-describedby="exp_cartao"
                                        :class="{ 'is-invalid': formularioStore.errors.exp_cartao, 'is-valid': formularioStore.validated.exp_cartao }"
                                        placeholder="MM/AA">
                                    <span v-if="formularioStore.errors.exp_cartao" class="text-danger">
                                        {{ formularioStore.errors.exp_cartao }}
                                    </span>
                                </div>
                                <div class="col-md-6">
                                    <label for="cvv" class="form-label form-titulo">Cód. de Segurança<span
                                            class="vermelho">*</span>:</label>
                                    <input v-model="formularioStore.cvv" v-mask="'####'" type="text"
                                        class="form-control" id="cvv" aria-describedby="cvv"
                                        :class="{ 'is-invalid': formularioStore.errors.cvv, 'is-valid': formularioStore.validated.cvv }">
                                    <span v-if="formularioStore.errors.cvv" class="text-danger">
                                        {{ formularioStore.errors.cvv }}
                                    </span>
                                </div>
                                <div class="col-md-12">
                                    <label for="nome_titular">Nome do titular<span class="vermelho">*</span>:</label>
                                    <input v-model="formularioStore.nome_titular" type="text" class="form-control"
                                        id="nome_titular" aria-describedby="nome_titular"
                                        :class="{ 'is-invalid': formularioStore.errors.nome_titular, 'is-valid': formularioStore.validated.nome_titular }">
                                    <span v-if="formularioStore.errors.nome_titular" class="text-danger">
                                        {{ formularioStore.errors.nome_titular }}
                                    </span>
                                </div>
                                <div class="col-md-6">
                                    <label for="cpf_titular">CPF do Titular<span class="vermelho">*</span>:</label>
                                    <input v-model="formularioStore.cpf_titular" v-mask="'###.###.###-##'" type="tel"
                                        class="form-control" id="cpf_titular" aria-describedby="cpf_titular"
                                        :class="{ 'is-invalid': formularioStore.errors.cpf_titular, 'is-valid': formularioStore.validated.cpf_titular }">
                                    <span v-if="formularioStore.errors.cpf_titular" class="text-danger">
                                        {{ formularioStore.errors.cpf_titular }}
                                    </span>
                                </div>
                                <div class="col-md-6">
                                    <label for="bandeira_cartao">Bandeira do Cartão<span
                                            class="vermelho">*</span>:</label>
                                    <select v-model="formularioStore.bandeira_cartao" type="text" class="form-select"
                                        id="bandeira_cartao" aria-describedby="bandeira_cartao"
                                        :class="{ 'is-invalid': formularioStore.errors.bandeira_cartao, 'is-valid': formularioStore.validated.bandeira_cartao }">
                                        <option value="visa">Visa</option>
                                        <option value="mastercard">Mastercard</option>
                                        <option value="diners">Diners</option>
                                        <option value="amex">Amex</option>
                                        <option value="elo">Elo</option>
                                        <option value="hipercard">Hipercard</option>
                                    </select>
                                    <span v-if="formularioStore.errors.bandeira_cartao" class="text-danger">
                                        {{ formularioStore.errors.bandeira_cartao }}
                                    </span>
                                </div>
                            </div>
                        </Transition>


                        <div class="row padding_categoria">
                            <div class="col-md-12">
                                <p> <i>
                                        Os valores serão usados exclusivamente para apoiar a nossa missão de
                                        distribuir esta Estampa abençoada a mais lares.
                                    </i>
                                </p>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" name="aceito" id="aceito"
                                        v-model="formularioStore.termos_condicoes">
                                    <label class="form-check-label" for="aceito"
                                        style="max-width: 100%; font-size:10pt">
                                        Aceito receber outros conteúdos em meu WhatsApp e demais aplicativos de
                                        mensagem. <a href="https://reginafidei.com.br/termos-e-condicoes/"
                                            target="_blank">Termos e
                                            Condições</a>.
                                    </label>
                                    <!-- <span v-if="formularioStore.errors.termos_condicoes" class="text-danger">
                                            {{ formularioStore.errors.termos_condicoes }}
                                        </span> -->
                                </div>
                            </div>
                        </div>

                        <div class="row padding_form mt-3">
                            <div class="col-md-6 offset-md-3">
                                <button type="submit" class="w-100 btn btn-lg btn-verde text-white">
                                    <span v-if="formularioStore.forma_pagamento == 'credito'">FINALIZAR
                                        DOAÇÃO</span>
                                    <span v-if="formularioStore.forma_pagamento == 'pix'">GERAR PIX</span>
                                    <span v-if="formularioStore.forma_pagamento == 'boleto'">GERAR BOLETO</span>
                                    <span v-if="formularioStore.forma_pagamento == 'paypal'">CONTINUAR</span>
                                    <span v-if="!formularioStore.forma_pagamento">CONTINUAR</span>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <!-- PIX -->
            <div class="row justify-content-center" v-if="formularioStore.pix_codigo">
                <div class="col-12 d-flex justify-content-center">
                    <div class="col-12 col-md-6 text-center">
                        <p style="background-color: red; border: #000 solid 2px; color: #fff; text-decoration: underline;"
                            class="fw-bold">FAÇA SUA DOAÇÃO NOS PRÓXIMOS <span style="color: yellow;">{{ tempoFormatado
                            }}</span></p>
                    </div>
                </div>
                <div class="d-flex col-md-12 justify-content-center">
                    <div class="col-md-4">
                        <img :src="formularioStore.pix_imagem" alt="QrCode do Pix" class="img-fluid">
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-12 col-md-8 text-center">
                        <p class="fw-bold">Dúvida em como realizar o pagamento?</p>

                        <p><span class="fw-bold">1. </span>Entre no aplicativo da sua instituição financeira e
                            acesse a
                            <span class="fw-bold">área “Pix”.</span>
                        </p>
                        <p><span class="fw-bold">2. </span>Escolha a opção ler <span class="fw-bold">QR code.</span>
                        </p>
                        <p><span class="fw-bold">3. </span>Ele abrirá sua câmera e você a aproximará do <span
                                class="fw-bold">QR
                                code.</span></p>
                        <p><span class="fw-bold">4. </span>Confirme as informações, o valor de doação e autorize o
                            pagamento</p>
                        <p>Em caso de erros, copie o código informado e, na instituição financeira do seu banco,
                            acesse
                            <span class="fw-bold">“Pix Copia e
                                Cola” e cole o código.</span>
                        </p>
                    </div>
                </div>
                <div class="col-md-8 mt-3">
                    <div class="input-group">
                        <input type="text" class="form-control" id="codigoPix" :value="formularioStore.pix_codigo"
                            readonly disabled>
                        <button @click="copiarTexto()" class="btn btn-outline-secondary" type="button"
                            id="copiarBtn">Copiar</button>
                    </div>
                    <p class="text-danger text-center" v-if="formularioStore.mensagem_copia == false">
                        Não foi possivel copiar o código pix
                    </p>
                    <p class="text-success text-center" v-if="formularioStore.mensagem_copia == true">
                        Código copiado!
                    </p>
                </div>
                <BotaoVoltar />
            </div>
            <!-- BOLETO -->
            <div class="row justify-content-center text-center" v-if="formularioStore.boleto_codigo">
                <!-- BOLETO GERADO
                Segue abaixo o código, clique em copiar -->
                <h4 for="codigoBoleto"><b>BOLETO GERADO</b></h4>
                <p class="fw-bold">Segue abaixo o código, clique em <b>copiar</b>.</p>
                <div class="row justify-content-center">
                    <div class="col-12 col-md-8">
                        <div class="input-group">
                            <input type="text" class="form-control" id="codigoBoleto"
                                :value="formularioStore.boleto_codigo" readonly disabled>
                            <button @click="copiarTexto()" class="btn btn-outline-secondary" type="button"
                                id="copiarBtn">Copiar</button>
                        </div>
                    </div>
                </div>
                <p class="fw-bold">Por favor, faça a sua doação como um Ato de Fé!</p>
                <p class="text-danger text-center" v-if="formularioStore.mensagem_copia == false">
                    Não foi possivel copiar o código pix
                </p>
                <p class="text-success text-center" v-if="formularioStore.mensagem_copia == true">
                    Código copiado!
                </p>
                <div class="row col-12 mt-3 justify-content-center">
                    <div class="col-6">
                        <a :href="formularioStore.boleto_url" class="btn btn-success p-3 w-100"
                            target="_blank"><b>BAIXAR BOLETO</b></a>
                    </div>
                </div>
                <BotaoVoltar />
            </div>
        </div>
    </div>
</template>

<script setup>

import { useFormularioStore } from '@/store/formulario'
import { useRoute } from 'vue-router';
import { VMoney } from 'v-money';
import { onMounted, ref, watch, computed } from 'vue';
import { Tooltip } from 'bootstrap';
import BotaoVoltar from '../BotaoVoltar.vue';

const formularioStore = useFormularioStore()
const route = useRoute()

const submitForm = () => {
    if (formularioStore.validacao()) {
        console.log('💨 Enviando...');
    }
}

onMounted(() => {
    // Inicializar Tooltip no elemento com o atributo data-bs-toggle="tooltip"
    const tooltips = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    tooltips.forEach(el => new Tooltip(el)); // Inicializa o tooltip
})

let textoParaCopiar = null
const copiarTexto = () => {
    if (formularioStore.pix_codigo) {
        textoParaCopiar = formularioStore.pix_codigo
    }
    if (formularioStore.boleto_codigo) {
        textoParaCopiar = formularioStore.boleto_codigo
    }

    if (navigator.clipboard) {
        navigator.clipboard.writeText(textoParaCopiar)
            .then(() => {
                formularioStore.mensagem_copia = true
            })
            .catch((error) => {
                formularioStore.mensagem_copia = false
            });
    } else {
        // Caso o navegador não suporte a API clipboard
        // alert('Seu navegador não suporta a funcionalidade de cópia.');
    }
}

const setaCheckbox = () => {
    document.getElementById("valoutro").checked = true
    formularioStore.valor_doacao = null
}

const money = {
    decimal: ',',
    thousands: '.',
    precision: 2,
}

const origem = route.query.origem;

if (origem) {
    formularioStore.fatura.origem_id = origem;
    formularioStore.doador.origem_id = origem;
}

// Temporizador
const tempoRestante = ref(300);
let timer = null;

// Computed para exibir o tempo formatado (mm:ss)
const tempoFormatado = computed(() => {
    const minutos = Math.floor(tempoRestante.value / 60);
    const segundos = tempoRestante.value % 60;
    return `${minutos}:${segundos.toString().padStart(2, "0")}`;
});

// Observa mudanças em pix_codigo e reinicia o temporizador
watch(() => formularioStore.pix_codigo, (novoValor) => {
    console.log("🔄 Mudou o pix_codigo:", novoValor);

    if (novoValor) {
        pararTemporizador(); // Para o temporizador anterior (se existir)
        tempoRestante.value = 300; // Reinicia o tempo
        iniciarTemporizador(); // Inicia o novo temporizador
    }
});

// Inicia o temporizador
function iniciarTemporizador() {
    if (timer) clearInterval(timer); // Garante que não há múltiplos intervalos

    timer = setInterval(() => {
        if (tempoRestante.value > 0) {
            tempoRestante.value--;
        } else {
            pararTemporizador();
            recarregarPagina(); // Dá F5 quando o tempo chega a 0
        }
    }, 1000);
}

// Para o temporizador
function pararTemporizador() {
    if (timer) {
        clearInterval(timer);
        timer = null;
    }
}

// Recarrega a página (F5)
function recarregarPagina() {
    window.location.reload();
}

</script>